import { fork } from "redux-saga/effects";
import ShopSaga from "./sagas/ShopSaga";
import SupportSaga from "./sagas/SupportSaga";
import GiftWithPurchaseSaga from "./sagas/GiftWithPurchaseSaga";
import RestMiniGiftWithPurchaseSaga from "./sagas/RestMiniGiftWithPurchaseSaga";
import { isNewCartEnabled } from "./utils/general";
import {
  isRestMiniGWPEnabled,
  isCloudPillowGWPEnabled,
  isAutoApplyDiscountCodeEnabled,
  getAutoApplyDiscountCode,
} from "./utils/promos";

export default function* root(store) {
  if (isNewCartEnabled()) {
    yield fork(ShopSaga().watcher);
  }

  if (
    isCloudPillowGWPEnabled() &&
    isAutoApplyDiscountCodeEnabled() &&
    getAutoApplyDiscountCode()
  ) {
    // alert('isCloudPillowGWPEnabled');
    yield fork(GiftWithPurchaseSaga().watcher);
  } else if (
    isRestMiniGWPEnabled() &&
    isAutoApplyDiscountCodeEnabled() &&
    getAutoApplyDiscountCode()
  ) {
    // alert('isRestMiniGWPEnabled');
    yield fork(RestMiniGiftWithPurchaseSaga().watcher);
  }

  yield fork(SupportSaga().watcher);
}
